// cos monikers
export const COS_APP_MONIKER_DEV = 'flu-c-uw2';
export const COS_APP_MONIKER_STG = 'flu-s-ue1';
export const COS_APP_MONIKER_PROD = 'flu-p-ue1';
// URL
export const URL_FORGE_STG = 'https://developer-stg.api.autodesk.com';
export const URL_FORGE_PROD = 'https://developer.api.autodesk.com';
export const URL_USER_PROFILE_STG =
  'https://developer-stg.api.autodesk.com/userprofile/v1/users/@me';
export const URL_USER_PROFILE_PROD = 'https://developer.api.autodesk.com/userprofile/v1/users/@me';
export const URL_LOGOUT_STG = 'https://accounts-staging.autodesk.com/Authentication/LogOut';
export const URL_LOGOUT_PROD = 'https://accounts.autodesk.com/Authentication/LogOut';
export const URL_ACCOUNTS_STG = 'https://accounts-staging.autodesk.com';
export const URL_ACCOUNTS_PROD = 'https://accounts.autodesk.com';

export const URL_AUTHORIZE_STG =
  'https://developer-stg.api.autodesk.com/authentication/v2/authorize';
export const URL_AUTHORIZE_PROD =
  'https://developer-stg.api.autodesk.com/authentication/v2/authorize';
export const URL_AUTHENTICATE_TOKEN_STG =
  'https://developer-stg.api.autodesk.com/authentication/v2/token';
export const SCOPE = 'bucket:create bucket:read data:read data:create data:write data:search';
export const LOCALHOST_DEPLOY_CLIENT_ID = '5E7AKeTrmZZdxcAF8zXgzDGNY79tDGQu';
export const LOCALHOST_DEPLOY_CALLBACK_URL = 'http://localhost:3000/';

// forge schema
export const URL_FSS_DEV = 'https://developer-stg.api.autodesk.com/schema-alpha/v1';
export const URL_FSS_STG = ''; // 'https://developer-stg.api.autodesk.com/schema/v1';
export const URL_FSS_CDN_STG = ''; // 'https://d2l8zltif9w3t9.cloudfront.net';
export const URL_FSS_PROD = ''; // 'https://developer.api.autodesk.com/schema/v1';

// github - hfdm schema
export const URL_ADSK_GITHUB_URL = 'git';
export const FORGE_SCHEMA_TITLE = 'UPS';
export const FORGE_SCHEMA_REPOSITORY = 'HFDMSchemas';
export const FORGE_SCHEMA_OWNER = 'forge';
export const FORGE_SCHEMA_BRANCH = 'master';
export const FORGE_SCHEMA_ROOT_FOLDER = 'schemas/autodesk';

export const TEST_SCHEMA_TITLE = 'Test';
export const TEST_SCHEMA_REPOSITORY = 'SchemaSandbox';
export const TEST_SCHEMA_OWNER = 'xiap';
export const TEST_SCHEMA_BRANCH = 'master';
export const TEST_SCHEMA_ROOT_FOLDER = 'schemas/testups/lookup';

// github - schema localization
export const URL_LOCALIZATION_GITHUB_URL = 'gitcontractors';
export const NAME_FORGE_SCHEMA_LOCALIZATION_REPOSITORY = 'ForgeSchemasLocalization';
export const NAME_FORGE_SCHEMA_LOCALIZATION_OWNER = 'LocalizationWorkspace';

// github - pim schema
export const PIM_SCHEMA_TITLE = 'PIM';
export const PIM_SCHEMA_REPOSITORY = 'pim-mono';
export const PIM_SCHEMA_OWNER = '1f-components';
export const PIM_SCHEMA_BRANCH = 'master';
export const PIM_SCHEMA_ROOT_FOLDER = 'sdks/pim-core-sdk/src/schemaManager/schemas/autodesk';

// github - pset-atf schema
export const PSET_ATF_SCHEMA_TITLE = 'PSET-ATF';
export const PSET_ATF_SCHEMA_REPOSITORY = 'atf';
export const PSET_ATF_SCHEMA_OWNER = 'modeling-components';
export const PSET_ATF_SCHEMA_BRANCH = 'develop';
export const PSET_ATF_SCHEMA_ROOT_FOLDER = 'source/fdx_util/schemas/autodesk';

// Resiliency constants
export const DEFAULT_RETRY_COUNT = 3;
